<template>
  <div :class="jel_getClassObject(content)">
    <div class="container p-0">
      <div class="limit-frame">
        <div class="text-left">
          <!-- Aucune erreur système (cas normal)  -->
          <div class="period-buttons">
            <a
              v-for="key in tabs"
              :key="key"
              :href="`#${key}`"
              class="btn"
              :class="{ active: activeTab === key }"
              @click="activeCategory(key, $event)"
            >
              <svg-icon
                aria-label="share"
                class="svg-icon-share stat-item-icon"
                :icon-name="getIconName(key)"
              ></svg-icon>
              {{ $t(`compte.limite.${key}`) }}
            </a>
          </div>
          <div
            id="spinner"
            :class="{
              'd-flex flex-column justify-content-center align-items-center text-center':
                isSpinnerVisible,
              'd-none': !isSpinnerVisible,
            }"
          >
            <b-spinner :label="$t('chargement')"></b-spinner>
          </div>

          <div v-show="!isSpinnerVisible">
            <!-- Affichage des erreurs systèmes -->
            <div v-if="isErreurServeur[activeTab]">
              <MessageMel
                v-show="contentMessageMel.message"
                :content="contentMessageMel.message"
                class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
              ></MessageMel>
            </div>

            <div v-else-if="limits[activeTab]">
              <div class="info-category">
                <Paragraphe
                  :content="{
                    richText: getContentDescription(activeTab),
                    classeCSS: 'text-left',
                  }"
                  class="texte-desc"
                ></Paragraphe>
                <div class="lien-aide">
                  <Hyperlien
                    class="ico-lien-aide rounded-circle cercleInfo"
                    :content="contentLienAideLimitesJeux(activeTab)"
                  ></Hyperlien>
                </div>
              </div>
              <LimitSection
                :key="activeTab"
                :category="activeTab"
                :limitValues="limits[activeTab]"
                :content="content"
              />
            </div>
          </div>
          <Paragraphe
            v-if="activeTab === 'time'"
            :content="{
              richText: content.textLegal,
              classeCSS: 'px-2 py-2',
            }"
            class="texte-desc"
          ></Paragraphe>
          <div class="item-frame">
            <svg-icon
              aria-label="share"
              class="svg-icon-share stat-item-icon"
              icon-name="ic-limit-frame"
            ></svg-icon>
            <Paragraphe
              :content="{
                richText: content.txtInfoExterne,
                classeCSS: 'px-2',
              }"
              class="texte-item-frame"
            ></Paragraphe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LimitSection from '@/components/compte/bienJouer/LimitSection';
import session from '@/services/api/compte/session';
import encadrerJeux from '@/services/api/compte/encadrerJeux';
import MessageMel from '@/components/base/MessageMel';
import MessageHelpers from '@/helpers/MessageHelpers';
import Paragraphe from '@/components/base/Paragraphe';
import Hyperlien from '@/components/base/Hyperlien';
import { inMgnl } from '@/helpers/AppHelpers';
import { bus } from '@/main';

export default {
  name: 'CompteLimitesBienJouer',
  components: {
    MessageMel,
    Paragraphe,
    LimitSection,
    Hyperlien,
  },
  props: { content: { type: Object, required: true }, metadata: { type: Object } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          deposit: 'limite-de-depot',
          time: 'limite-de-temps',
          loss: 'limite-de-pertes',
        },
      },
      en: {
        messageComponent: {
          deposit: 'deposit-limit',
          time: 'time-limit',
          loss: 'loss-limit',
        },
      },
    },
  },
  data() {
    return {
      isSpinnerVisible: false,
      message: null,
      contentMessageMel: {
        message: {},
        alert: {},
      },
      isErreurServeur: {},
      tabs: ['deposit', 'time', 'loss'],
      activeTab: 'deposit',
      limits: {},
    };
  },
  computed: {
    // Créer un mapping inverse pour la locale actuelle
    reverseMessageComponentMap() {
      const currentLocale = this.$i18n.locale;
      const messages = this.$i18n.messages[currentLocale].messageComponent;
      const reverseMap = {};
      Object.entries(messages).forEach(([key, value]) => {
        reverseMap[value] = key;
      });

      return reverseMap;
    },
  },

  async mounted() {
    // Afficher le spinner au chargement de la page sauf dans Magnolia
    if (inMgnl) {
      this.isSpinnerVisible = false;
    }
    // Dans le cas d'un lien direct via un hash
    const { hash } = window.location;
    if (hash) {
      const keyTabActive = this.reverseMessageComponentMap[hash.replace('#', '')] || null;
      if (this.tabs.includes(keyTabActive)) {
        this.activeTab = keyTabActive;
      }
    }
    await this.getLimiteJeux(this.activeTab);
  },

  methods: {
    contentLienAideLimitesJeux(activeTab) {
      const key = activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
      if (!this.content[`idQuestionLimite${key}`]) {
        return null;
      }
      return {
        texte: 'i',
        type: 'aide text-decoration-none',
        idQuestion: this.content[`idQuestionLimite${key}`],
        lien: {
          field: 'aide',
          idAide: this.content[`idQuestionLimite${key}`],
        },
      };
    },

    getContentDescription(activeTab) {
      const key = activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
      return this.content[`description${key}`];
    },

    getIconName(activeTab) {
      return `ic-limit-${activeTab}`;
    },

    isSessionOuverte() {
      return session.sessionEstOuverte();
    },

    viderMessageMel() {
      this.contentMessageMel.message = '';
    },

    async activeCategory(key, event) {
      event.preventDefault();
      this.activeTab = key;
      window.location.hash = this.$i18n.t(`messageComponent.${key}`);
      await this.getLimiteJeux(key);
    },

    async getLimiteJeux(category) {
      this.isSpinnerVisible = true;
      encadrerJeux
        .getLimiteJeux(category)
        .then(() => {
          this.limits = this.$store.getters['encadrerJeux/getLimits'];
          this.isErreurServeur[category] = false;
          this.isSpinnerVisible = false;
          bus.$emit('get-limit-received');
        })
        .catch((error) => {
          this.recupererMessage('MSG01', 'message');
          this.isErreurServeur[category] = true;
          this.isSpinnerVisible = false;
        });
    },

    recupererMessage(codeMessage, contentMessage) {
      MessageHelpers.obtenirMessage(codeMessage, this.$root)
        .then((msgResp) => {
          this.contentMessageMel[contentMessage] = {
            titre: msgResp.msgTitre,
            message: msgResp.msgDetail,
            msgType: msgResp.msgType,
          };
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.item-frame {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  background: var(--Color-Blue-200, #e6f2fd);
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.texte-item-frame {
  align-self: stretch;
  color: var(--Color-Blue-900, #020a30);
  font-family: Graphik;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.225rem;
}

.texte-desc {
  flex: 1 0 0;
}

.limit-frame {
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
}

.texte-legal {
  font-size: 13px;
  line-height: 17px;
  color: $couleur-bleu-fonce-lq;
}

/* Classe bootstrap d-inline-block remplacée par ceci car le !important ajouté par bootstrap entre en conflit avec le v-show */
.mel-erreur,
.mel-succes,
.mel-avertissement,
.mel-info {
  display: inline-block;
  color: $couleur-blanc;
}

.lien-retour:hover {
  text-decoration: none;
}

.icone-fleche {
  margin-right: 4px;
}

.absolute-bottom {
  position: absolute;
  bottom: 0;
}

::v-deep .mel-avertissement,
.message-succes {
  display: block !important;
}

.period-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 1rem;
}

.period-buttons .btn {
  display: flex;
  width: 100%;
  height: 2.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-weight: bold;
  border-radius: 0.25rem;
  border: 1px solid $couleur-btn-bien-jouer;
  background: $couleur-blanc;
}

.period-buttons .btn.active {
  background: $couleur-btn-bien-jouer;
}

.stat-item-icon {
  display: flex;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.info-category {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}

.lien-aide {
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.29763rem;
}

.label {
  font-weight: bold;
}

.bouton.info {
  margin: 0 !important;
  color: white;
}
</style>
